import type { SVGProps } from "react";
import { Icon, type IconProps } from "../Icon";
const InternalSvg = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="currentColor"
    viewBox="0 0 24 24"
    {...props}
  >
    <g clipPath="url(#linkedin_svg__a)">
      <path d="M20.3 2.05H3.5c-.8 0-1.5.6-1.5 1.4v17c0 .8.7 1.4 1.5 1.4h16.8c.8 0 1.5-.6 1.5-1.4v-17c0-.8-.7-1.4-1.5-1.4M8 18.75H5v-9h3zM6.5 8.45c-1 0-1.7-.7-1.7-1.6s.7-1.6 1.7-1.6 1.6.7 1.7 1.6c0 1-.7 1.6-1.7 1.6m12.3 10.3h-3v-4.8c0-1.2-.4-2-1.5-2-.8 0-1.3.6-1.5 1.1-.1.2-.1.5-.1.7v5h-3v-9h3v1.3c.4-.6 1.1-1.5 2.7-1.5 2 0 3.4 1.3 3.4 4z" />
    </g>
    <defs>
      <clipPath id="linkedin_svg__a">
        <path fill="#fff" d="M2 2.05h19.8v19.9H2z" />
      </clipPath>
    </defs>
  </svg>
);
export const LinkedinIcon = (props: IconProps) => (
  <Icon {...props} Icon={InternalSvg} />
);
